module.exports = __webpack_public_path__ + "img/Julie.54bfd557.png";